<p *ngIf="description">
    <span [innerHTML]="description"><br /><br/></span>
</p>
